/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import {GenogramNodeSizeScaleEnum} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramNodeSizeScaleEnum";
import {isStickyNoteNodeData} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramStickyNoteHelper";

export const GENOGRAM_NODE_SIZE_SCALE_FIELD = "sizeScale"

const DEFAULT_NODE_SYMBOL_SIZE = 76

export function getGenogramNodeSizeScaleOptions() {
	return [
		{value: GenogramNodeSizeScaleEnum.SMALL, label: "Small symbol"},
		{value: GenogramNodeSizeScaleEnum.STANDARD, label: "Standard symbol"},
		{value: GenogramNodeSizeScaleEnum.LARGE, label: "Large symbol"},
	]
}

export function isGenogramNodeSizeScaleEligible(nodeData = {}) {
	return !nodeData.isAuxNode && !isStickyNoteNodeData(nodeData)
}

export function getGenogramNodeSizeScale(nodeData = {}) {
	let sizeScale = Number(nodeData[GENOGRAM_NODE_SIZE_SCALE_FIELD])
	let result = GenogramNodeSizeScaleEnum.STANDARD
	if(Number.isFinite(sizeScale) && sizeScale > 0){
		result = sizeScale
	}
	return result
}

export function setGenogramNodeSizeScale(nodeData = {}, sizeScale) {
	let normalizedScale = getNormalizedGenogramNodeSizeScale(sizeScale)
	nodeData[GENOGRAM_NODE_SIZE_SCALE_FIELD] = normalizedScale
	return nodeData
}

export function getCommonGenogramNodeSizeScale(nodeDataArray = []) {
	let result = null
	let hasScale = false
	for(let nodeData of nodeDataArray){
		if(!isGenogramNodeSizeScaleEligible(nodeData)){
			continue
		}
		let sizeScale = getGenogramNodeSizeScale(nodeData)
		if(!hasScale){
			result = sizeScale
			hasScale = true
			continue
		}
		if(result !== sizeScale){
			result = null
			break
		}
	}
	return result
}

export function getRenderedGenogramNodeWidth(nodeData = {}) {
	return getRenderedGenogramNodeDimension(nodeData, "width")
}

export function getRenderedGenogramNodeHeight(nodeData = {}) {
	return getRenderedGenogramNodeDimension(nodeData, "height")
}

function getRenderedGenogramNodeDimension(nodeData, dimensionField) {
	let baseDimension = getBaseGenogramNodeDimension(nodeData, dimensionField)
	let scale = isGenogramNodeSizeScaleEligible(nodeData) ? getGenogramNodeSizeScale(nodeData) : GenogramNodeSizeScaleEnum.STANDARD
	return baseDimension * scale
}

function getBaseGenogramNodeDimension(nodeData = {}, dimensionField) {
	return Number(nodeData[dimensionField]) || DEFAULT_NODE_SYMBOL_SIZE
}

function getNormalizedGenogramNodeSizeScale(sizeScale) {
	let numericScale = Number(sizeScale)
	let result = GenogramNodeSizeScaleEnum.STANDARD
	if(Number.isFinite(numericScale) && numericScale > 0){
		result = numericScale
	}
	return result
}
